module.exports = __webpack_public_path__ + "media/6.d083c12e.ogg";